import { render, staticRenderFns } from "./InboxAdd.vue?vue&type=template&id=43fd51c0"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43fd51c0')) {
      api.createRecord('43fd51c0', component.options)
    } else {
      api.reload('43fd51c0', component.options)
    }
    module.hot.accept("./InboxAdd.vue?vue&type=template&id=43fd51c0", function () {
      api.rerender('43fd51c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/InboxAdd.vue"
export default component.exports